import React from "react"
import { connect } from "react-redux"
import Draggable from "react-draggable"

import arrow from "../../images/icon/info-box-arrow.svg"
import exitIcon from "../../images/icon/exit.svg"
import { setShowInfoPopup, setShowAnnoucementBar } from "../../state/global"

const InfoPopup = ({
  dispatch,
  mobile,
  show,
  data,
  showAnnouncement,
  announcementData,
  dragging,
  announcement = false,
}) => {
  let { type, title, info, link } = data
  return (
    <>
      {announcement & !dragging && (
        <div
          className={`information-popup-container--announcement ${
            showAnnouncement ? "show" : ""
          }`}
        >
          <div className="inner-box">
            <div
              className="title-container"
              onClick={() => dispatch(setShowAnnoucementBar(true))}
              onKeyDown={() => dispatch(setShowAnnoucementBar(true))}
              role="button"
              tabIndex={0}
            >
              <span className="close-icon">
                <img src={arrow} alt="" />
              </span>
              <span className="title">News</span>
            </div>

            <div className="announcement-box">
              <div
                className="close-icon"
                onClick={() => dispatch(setShowAnnoucementBar(false))}
                onKeyDown={() => dispatch(setShowAnnoucementBar(false))}
                role="button"
                tabIndex={0}
              >
                <img src={arrow} alt="" />
              </div>
              <div className="community-title">{announcementData.title}</div>
              <div className="community-body">{announcementData.info}</div>
            </div>
          </div>
        </div>
      )}

      {show && (
        <Draggable disabled={mobile}>
          <div
            className={`${type} information-popup-container ${
              show ? "show" : ""
            }`}
          >
            <div className="inner-box">
              <div
                className="close-icon"
                onClick={() => dispatch(setShowInfoPopup(false))}
                onKeyDown={() => dispatch(setShowInfoPopup(false))}
                role="button"
                tabIndex={0}
              >
                <img src={exitIcon} alt="" />
              </div>
              {type === "caseStudy" && <div className="content">{info}</div>}
              {type === "community" && (
                <>
                  <div className="community-title">{title}</div>
                  <div className="community-body">{info}</div>
                  <div className="community-link">
                    <a href={link}>Learn More Here</a>
                  </div>
                </>
              )}
            </div>
          </div>
        </Draggable>
      )}
    </>
  )
}

export default connect(
  state => ({
    dragging: state.navbar.dragging,
    mobile: state.global.mobile,
    show: state.global.showInfoPopup,
    data: state.global.infoPopupData,
    showAnnouncement: state.global.showAnnouncementBar,
    announcementData: state.global.announcementBarData,
  }),
  null
)(InfoPopup)
